
// 引用axios
var axios = require('axios')

function apiAxios (url, ip) {
    axios({
        method: 'get',
        url: url,
        headers:{
            'Content-Type':"application/json;charset=UTF-8",
            'Ip':ip
        },
        params: {},
    })
    .then(res => {
        console.log(res)
    }).catch(err=>{
        console.log(err)
    })
}
// 返回在vue模板中的调用接口
export default {
  export: function (url, ip) {
    return apiAxios (url, ip)
  }
}


// WEBPACK FOOTER //
// ./src/axios_api/GetProgressNum.js